import React from 'react'
import { Button, Row, Col, InputGroup } from 'react-bootstrap'
import Fader from './Fader.js'
import NumberInput from './NumberInput.js'
import MSelect from './MSelect.js'
import Input from './Input.js'
import Meter from './meter.js'
import Util from './util.js'
import { withPrefix } from 'gatsby'
class DCSound extends React.Component {
  constructor(props) {
      super(props);
      this.state={csoundLoaded:"loading",csndstatus:'dbyellow'};
      this.def = {};
      this.meter = { width:26 , height: 200 }
      this.def.hvsamp = { id : 'hvsamp', type : 'fader', label : 'amp', min: -60, max: 0, step: 1, defval: -19, height: 200 }
      this.def.hvsrev = { id : 'hvsrev', type : 'fader', label : 'reverb', min: 0, max: 1, step: 0.01, defval: 0.19, height: 200 }
      this.def.hvsdel = { id : 'hvsdel', type : 'fader', label : 'delay', min: 0, max: 1, step: 0.01, defval: 0.1, height: 200 }
      this.def.hvsens = { id : 'hvsens', type : 'fader', label : 'ens', min: 0, max: 1, step: 0.01, defval: 0.05, height: 200 }
      this.def.hvsfilt = { id : 'hvsfilt', type : 'fader', label : 'filter', log:true, min: 40, max: 15000, step: 0.01, defval: 4346, height: 200 }
      this.def.hvsres = { id : 'hvsres', type : 'fader', label : 'res', min: 0, max: 1, step: 0.01, defval: 0.5, height: 200 }
      this.def.drums = { id : 'drums', type : 'fader', label : 'drums', min: -60, max: 0, step: 1, defval: -9, height: 200 }
      this.def.seed = { id : 'seed', type : 'numberinput', label : 'seed', size:"7", min: 0, max: 1000000, step: 1, defval: 846729 }
      this.def.pathseed = { id : 'pathseed', type : 'numberinput', label : 'pseed', size:"7", min: 0, max: 100000, step: 1, defval: 19281 }
      this.def.tempo = { id : 'tempo', type : 'numberinput', label : 'bpm', size:"7", min: 40, max: 200, step: 0.1, defval: 120 }
      this.def.oct = { id : 'oct', type : 'numberinput', label : 'oct', size:"7", min: 0, max: 5, step: 1, defval: 1 }
      this.def.wave = { id : 'wave', type : 'select', label : 'wave', defval: 5 , vertical:true,items:[
                                { name:'sine',value:0},
                                { name:'sin2',value:1},
                                { name:'saw',value:2},
                                { name:'pls',value:3},
                                { name:'tri',value:4},
                                { name:'rnd',value:5},
                                { name:'vcosaw',value:6},
                                { name:'vcopls',value:7},
                                { name:'vcotri',value:8},
                    ]}
      this.def.scale = { id : 'scale', type : 'select', label : 'scales', defval: 6, vertical:true,
                       items: [
                                { name:'harmonic',value:0},
                                { name:'even',value:1},
                                { name:'odd',value:2},
                                { name:'limit',value:3},
                                { name:'majb7',value:4},
                                { name:'maj7-5+',value:5},
                                { name:'min-blue',value:6},
                                { name:'min-zo',value:7},
                                { name:'phry',value:8},
                              ]}
      this.def.rvar = { id : 'rvar', type : 'select', label : 'var', defval: 2, vertical:true,
                       items: [
                                { name:'var1',value:0},
                                { name:'var2',value:1},
                                { name:'rnd',value:2},
                              ]}

      this.def.dist = { id : 'dist', type : 'select', label : 'dist', defval: 3, vertical:true,
                       items: [
                                { name:'cauchy',value:0},
                                { name:'beta',value:1},
                                { name:'weibull',value:2},
                                { name:'discrete',value:3},
                              ]}
      this.def.dens = { id : 'dens', type : 'fader', label : 'dens', min: 0.001, max: 0.2, step: 0.001, defval: 0.2 }
      this.def.dmp = { id : 'dmp', type : 'fader', label : 'dmp', min: 0.01, max: 1, step: 0.01, defval: 0.8 }
      this.def.snarepat = { id: 'snarepat', label: 'snare', defval:'0000700000007000000070000400700000007000000070000000700000037025'}
      this.def.bdpat = { id: 'bdpat', label: 'bd', defval:'90039000900090009000900090009004900090009000900090009000900090999003900090009000900090009000900390009000900090009000900090090090'}
      this.def.mrcapat = { id: 'mrcapat', label: 'mrca', defval:'0090'}
      this.def.clpat = { id: 'clpat', label: 'cl', defval:'00'}
      this.def.clappat = { id: 'clappat', label: 'clap', defval:'00'}
      this.def.clavpat = { id: 'clavpat', label: 'clav', defval:'00'}
      this.def.rspat = { id: 'rspat', label: 'rs', defval:'00'}
      this.def.ohpat = { id: 'ohpat', label: 'oh', defval:'00'}
      this.values = {};
      this.trigChange = false;
  }


  async componentDidMount() {
      const url = withPrefix("csound.esm.js");
      const { Csound } = await import(/* webpackIgnore: true */ url);
      this.csound = await Csound({
      });
      const csdresp = await fetch(withPrefix("random_house.csd"));
      let buf = await csdresp.text();
      let csd = "random_house.csd";
      this.csound.fs.writeFileSync(csd, buf);
      let result = await this.csound.compileCsd(csd);
      if(result) {
        this.setState({csoundLoaded:"compile csd failed"});
      } else {
        await this.csound.start();
        this.setState({csoundLoaded:"running"});
        this.setState({csndstatus:"dbgreen"});
        this.audioContext = await this.csound.getAudioContext();
        let isStarted = this.audioContext.state === "running";
        this.setState({started:isStarted});
        this.setDefaultValues();
	      this.isPlaying = false;
	      this.isStarted = false;
        this.csound.addListener("message",this.onMessage.bind(this));
	    }
  }

  onMessage(msg) {
    if(msg.startsWith("TRIG")) {
      console.log("LTRIG");
      if(this.trigChange) {
        console.log("setValues");
        this.setValues();
        this.trigChange = false;
      }
    }
  }
  setValues() {
    Object.keys(this.values).forEach( key => this.def[key].changeValue(this.values[key]));
  }

  setDefaultValues() {
    Object.keys(this.def).forEach( key => this.def[key].changeValue(this.def[key].defval));
  }

  componentWillUnmount() {
     if(this.csound) {
        this.csound.stop();
        this.csound.destroy();
     }
  }

  handleStart() {
     if(this.isPlaying) {
        this.handleStop();
     }
     if(!this.isStarted) {
        this.audioContext.resume();
        this.started = true;
     }
     this.csound.readScore('i "trigDrums" 0 3000');
     this.csound.readScore('i "hvs" 0 3000 27.5');
     this.isPlaying = true;
     setTimeout(() => this.updateMeter(),100);
  }

  handleRandom() {
       this.values.seed = Util.randomIntM(1000000);
       this.values.dist = Util.randomIntM(4); 
       this.values.pathseed = Util.randomIntM(100000);
       this.values.rvar = Util.randomIntM(3);
       this.values.wave = Util.randomIntM(9);
       this.values.scale = Util.randomIntM(9);
       this.values.dens = Util.random(0,0.2);
       this.values.dmp = Util.random(0,1);
       if(this.isPlaying) {
         this.trigChange = true;
       } else {
         this.setValues();
       }
  }
  handlePause() {
     if(this.started) {
       this.started = false;
       this.audioContext.suspend();
     }
  }

  handleContinue() {
     if(!this.started) {
       this.started = true;
       this.audioContext.resume();
     }
  }

  handleStop() {
     if(this.isPlaying) {
       this.csound.readScore('i "trigOff" 0 0.1');
       this.isPlaying = false;
       this.meter.change(0,0);
     }
  }

  async updateMeter() {
    if(this.isPlaying) {
      const left = await this.csound.getControlChannel("left");
      const right = await this.csound.getControlChannel("right");
      this.meter.change(left,right);
      setTimeout(() => this.updateMeter(),50);
    }
  }

  handleUpdate(id,val) {
    console.log(id,val);
    this.values[id]=val;
    this.csound && this.csound.setControlChannel(id,val);
  }

  handleStringUpdate(id,val) {
    console.log(id,val);
    this.values[id]=val;
    this.csound && this.csound.setStringChannel(id,val);
  }

  async handleSave() {
    const fileName = "file";
    const json = JSON.stringify(this.values);
    const blob = new Blob([json],{type:'application/json'});
    const href = await URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = href;
    link.download = fileName + ".json";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  upload(evt) {
      const fileObj = evt.target.files[0];
      const reader = new FileReader();
          
      let fileloaded = e => {
        const fileContents = e.target.result;
        try {
          if(this.isPlaying) {
            this.values = JSON.parse(fileContents);
            this.trigChange = true;
          } else {
            const values = JSON.parse(fileContents);
            Object.keys(values).forEach( key => {
               this.def[key] && this.def[key].changeValue(values[key]);
            });
          }
        } catch(e) {
          console.log(e);
        }
      }
      reader.onload = fileloaded.bind(this);
      reader.readAsText(fileObj);       
  }

  handleLoad(event) {
    event.preventDefault();
    this.dofileUpload.click();
  }

  render() {
 
    return (
      <>
      <Row>
	      <Col><Button block variant="secondary" size="sm" onClick={this.handleStart.bind(this)}>Start</Button></Col>
	      <Col><Button block variant="secondary" size="sm" onClick={this.handleStop.bind(this)}>Stop</Button></Col>
	      <Col><Button block variant="secondary" size="sm" onClick={this.handleRandom.bind(this)}>Random</Button></Col>
	      <Col><Button block variant="secondary" size="sm" onClick={this.handlePause.bind(this)}>Pause</Button></Col>
	      <Col><Button block variant="secondary" size="sm" onClick={this.handleContinue.bind(this)}>Continue</Button></Col>
	      <Col><Button block variant="secondary" size="sm" onClick={this.handleLoad.bind(this)}>Load</Button></Col>
	      <Col><Button block variant="secondary" size="sm" onClick={this.handleSave.bind(this)}>Save</Button></Col>
        <input type="file"
          style={{ display: 'none' }}
          multiple={false}
          accept=".json,application/json"
          onChange={evt => this.upload(evt)}
          ref={e=>this.dofileUpload = e} />

      </Row>
      <Row><Col className={this.state.csndstatus}>Csound {this.state.csoundLoaded}</Col></Row>
      <Row noGutters="true">
        <Col>
          <Row><Col><NumberInput vertical={false} def={this.def.seed} onChange={this.handleUpdate.bind(this)}/></Col></Row>
          <Row><Col><NumberInput vertical={false} def={this.def.pathseed} onChange={this.handleUpdate.bind(this)}/></Col></Row>
          <Row>
            <Col><MSelect vertical={true} def={this.def.rvar} onChange={this.handleUpdate.bind(this)}/></Col>
            <Col><MSelect vertical={true} def={this.def.dist} onChange={this.handleUpdate.bind(this)}/></Col>
          </Row>
        </Col>
        <Fader def={this.def.dens} key={this.def.dens.id} onChange={this.handleUpdate.bind(this)}/>
        <Col><MSelect vertical={true} def={this.def.wave} onChange={this.handleUpdate.bind(this)}/></Col>
        <Col><MSelect def={this.def.scale} onChange={this.handleUpdate.bind(this)} vertical={true}/></Col>
        <Fader def={this.def.dmp} key={this.def.dmp.id} onChange={this.handleUpdate.bind(this)}/>
        <Col md="auto"><Row noGutters>
        <Fader def={this.def.hvsamp} key={this.def.hvsamp.id} onChange={this.handleUpdate.bind(this)}/>
        <Fader def={this.def.hvsrev} key={this.def.hvsrev.id} onChange={this.handleUpdate.bind(this)}/>
        <Fader def={this.def.hvsdel} key={this.def.hvsdel.id} onChange={this.handleUpdate.bind(this)}/>
        <Fader def={this.def.hvsens} key={this.def.hvsens.id} onChange={this.handleUpdate.bind(this)}/>
        <Fader def={this.def.hvsfilt} key={this.def.hvsfilt.id} onChange={this.handleUpdate.bind(this)}/>
        <Fader def={this.def.hvsres} key={this.def.hvsres.id} onChange={this.handleUpdate.bind(this)}/>
        <Fader def={this.def.drums} key={this.def.drums.id} onChange={this.handleUpdate.bind(this)}/>
        <Meter def={this.meter} key="meter"/>
        </Row>
        <Row>
          <Col md="auto"><NumberInput vertical={false} def={this.def.tempo} onChange={this.handleUpdate.bind(this)}/></Col>
          <Col md="auto"><NumberInput vertical={false} def={this.def.oct} onChange={this.handleUpdate.bind(this)}/></Col>
        </Row>
        </Col>
      </Row>
      <Row><Col>&nbsp;</Col></Row>
      <Row><Col>
         <Input def={this.def.bdpat} onChange={this.handleStringUpdate.bind(this)} />
         <Input def={this.def.snarepat} onChange={this.handleStringUpdate.bind(this)} />
         <Input def={this.def.mrcapat} onChange={this.handleStringUpdate.bind(this)} />
         <Input def={this.def.clappat} onChange={this.handleStringUpdate.bind(this)} />
         <Input def={this.def.ohpat} onChange={this.handleStringUpdate.bind(this)} />
         <Input def={this.def.clpat} onChange={this.handleStringUpdate.bind(this)} />
         <Input def={this.def.clavpat} onChange={this.handleStringUpdate.bind(this)} />
         <Input def={this.def.rspat} onChange={this.handleStringUpdate.bind(this)} />
      </Col></Row>
      </>
    );

  }
}

export default DCSound
